/* CONSTANTS */
import * as constants from 'vd-constants';

class HierarchyUtil {
  static remapType = (type) => {
    if (type === 'admin') {
      return 'customer';
    } else if (type === 'standard') {
      return 'user';
    }
    return type;
  };

  static isTypeEqualOrHigher = ({ type: sourceType, minType: sourceMinType }) => {
    const type = HierarchyUtil.remapType(sourceType);
    const minType = HierarchyUtil.remapType(sourceMinType);
    // "higher" type means lower index in the array
    const TYPE_ORDER = [
      constants.OWNER_TYPE.SOLINK,
      constants.OWNER_TYPE.CLOUD,
      constants.OWNER_TYPE.RESELLER,
      constants.OWNER_TYPE.CUSTOMER,
      constants.OWNER_TYPE.USER,
    ];
    const index = TYPE_ORDER.indexOf(type);
    const minIndex = TYPE_ORDER.indexOf(minType);
    if (index === -1) {
      return false;
    }
    return index <= minIndex;
  };
}

export default HierarchyUtil;
